import React, { useState, useRef, useContext } from "react";
import { NavLink } from "react-router-dom";
import "./styles.css";
import Controls from "../../../containers/ui-styles/controls/controls";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MobileUserInfo from "../mobileUserInfo";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { roleContext, LanguageContext } from "../../../libs/context";
import { Auth, API } from "aws-amplify";
import * as AuthAPI from "../../../offline-auth/auth";
import { config } from "../../../config";
import { OffLineAPI } from "../../../offline-auth/api";

const _Auth = config.isOffline ? AuthAPI.Auth : Auth;
let _API = config.isOffline ? OffLineAPI : API;

function ResponsiveSideNav(props) {
  const language = useContext(LanguageContext);
  const { mobNav, mobShade, handleSlideOut, handleLogout } = props;
  const pathname = window.location.pathname;
  const refActiveIcon = useRef(pathname);
  const [open, setOpen] = useState(false);
  const [openReports, setOpenReports] = useState(false);
  const role = useContext(roleContext);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleOpenReports = () => {
    setOpenReports(!openReports);
  };

  return (
    <>
      <div className={mobNav ? "resNav resNavSlideIn" : "resNav"}>
        <div className="resNavBdy">
          <div className="overflowBlockCntnr">
            <div className="overflowCntnt">
              <div className="sideNavInfo">
                <div className="resNavHdr" onClick={props.handleSlide}>
                  <div className="resNavCloseBlock">
                    <img src="/images/logos/inclass-new.png" alt="inclass" />
                    <IconButton aria-label="close" onClick={handleSlideOut}>
                      <CloseIcon />
                    </IconButton>
                  </div>
                </div>
                <MobileUserInfo />
              </div>
              <div className="resNavListGroup">
                {/* <div className="resNavListItem" onClick={handleSlideOut}>
                                    <NavLink to="/dashboard" activeClassName="anchorActive" className="anchorTxt">
                                        <img ref={refActiveIcon} src="/images/blue/dashboard-24.png" alt="dashboard icon" className={`${pathname.match('/new-dashboard') ? "resSpanIcon" : "resSpanIcon invertGray"}`} />
                                        <span>Dashboard</span>
                                    </NavLink>
                                </div>
                                <div className="resNavListItem" onClick={handleSlideOut}>
                                    <NavLink to="/new-meetings" activeClassName="anchorActive" className="anchorTxt" >
                                        <img ref={refActiveIcon} src="/images/blue/my-meetings-24.png" alt="my meetings icon" className={`${pathname.match('/new-meetings') ? "resSpanIcon" : "resSpanIcon invertGray"}`} />
                                        <span>My Meetings</span>
                                    </NavLink>
                                </div>
                                <div className="resNavListItem" onClick={handleSlideOut}>
                                    <NavLink to="/calendar" activeClassName="anchorActive" className="anchorTxt" >
                                        <img ref={refActiveIcon} src="/images/blue/schedule-24.png" alt="schedule icon" className={`${pathname.match('/new-schedule') ? "resSpanIcon" : "resSpanIcon invertGray"}`} />
                                        <span>Schedule</span>
                                    </NavLink>
                                </div> */}
                {/* <div className="resNavListItem" onClick={handleSlideOut}>
                                    <NavLink to="/new-contacts" activeClassName="anchorActive" className="anchorTxt" >
                                        <img ref={refActiveIcon} src="/images/blue/my-contacts-24.png" alt="my contacts icon" className={`${pathname.match('/new-contacts') ? "resSpanIcon" : "resSpanIcon invertGray"}`} />
                                        <span>My Contacts</span>
                                    </NavLink>
                                </div> */}
                {/* <div className="resNavListItem" onClick={handleSlideOut}>
                                    <NavLink to="/new-settings" activeClassName="anchorActive" className="anchorTxt" >
                                        <img ref={refActiveIcon} src="/images/blue/settings-24.png" alt="settings icon" className={`${pathname.match('/new-settings') ? "resSpanIcon" : "resSpanIcon invertGray"}`} />
                                        <span>Settings</span>
                                    </NavLink>
                                </div> */}

                <div className="resNavListItem" onClick={handleSlideOut}>
                  <NavLink
                    to="/dashboard"
                    activeClassName="anchorActive"
                    className="anchorTxt"
                  >
                    <img
                      ref={refActiveIcon}
                      src="/images/blue/dashboard-24.png"
                      alt="dashboard icon"
                      className={`${pathname.match("/dashboard")
                        ? "resSpanIcon"
                        : "resSpanIcon invertGray"
                        }`}
                    />
                    <span>{language.instavc_myprofile_dashboard}</span>
                  </NavLink>
                </div>
                <div className="resNavListItem" onClick={handleSlideOut}>
                  <NavLink
                    to="/my-sessions"
                    activeClassName="anchorActive"
                    className="anchorTxt"
                  >
                    <img
                      ref={refActiveIcon}
                      src="/images/blue/my-meetings-24.png"
                      alt="my meetings icon"
                      className={`${pathname.match("/my-sessions")
                        ? "resSpanIcon"
                        : "resSpanIcon invertGray"
                        }`}
                    />
                    <span>{language.mySessions}</span>
                  </NavLink>
                </div>
                {(role === "Admin" || role === "subAdmin") && (
                  <div className="resNavListItem" onClick={handleSlideOut}>
                    <NavLink
                      to="/admin/user-management"
                      activeClassName="anchorActive"
                      className="anchorTxt"
                    >
                      <img
                        ref={refActiveIcon}
                        src="/images/blue/users.png"
                        alt="my meetings icon"
                        className={`${pathname.match("/admin/user-management")
                          ? "resSpanIcon"
                          : "resSpanIcon invertGray"
                          }`}
                      />
                      <span>{language.instavc_admin_users}</span>
                    </NavLink>
                  </div>
                )}
                {(role === "Admin" || role === "teacher" || role === "subAdmin") ? (
                  <>
                    <div className="resNavListItem" onClick={handleClick}>
                      <NavLink
                        to="/admin/class-management"
                        activeClassName="anchorActive"
                        className="anchorTxt"
                      >
                        <img
                          ref={refActiveIcon}
                          src="/images/icons/classes.png"
                          alt="schedule icon"
                          className={`${pathname.match("/admin/class-management")
                            ? "resSpanIcon"
                            : "resSpanIcon invertGray"
                            }`}
                        />
                        <span>{language.classes}</span>
                      </NavLink>
                      {open ? <ExpandLess /> : <ExpandMore />}
                    </div>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                      <div className="resNavListItem" onClick={handleSlideOut}>
                        <NavLink
                          activeClassName="anchorActive"
                          to="/admin/class-management"
                          className="anchorTxt menuItemLinks nestedListItem"
                        >
                          <span>{language.classes}</span>
                        </NavLink>
                      </div>
                      <div className="resNavListItem" onClick={handleSlideOut}>
                        <NavLink
                          activeClassName="anchorActive"
                          to="/admin/classmanagement/quesstionare"
                          className="anchorTxt menuItemLinks nestedListItem"
                        >
                          {language.questionnaire}
                        </NavLink>
                      </div>
                      <div className="resNavListItem" onClick={handleSlideOut}>
                        <NavLink
                          activeClassName="anchorActive"
                          to="/admin/classmanagement/assignment"
                          className="anchorTxt menuItemLinks nestedListItem"
                        >
                          {language.assignments}
                        </NavLink>
                      </div>
                    </Collapse>
                  </>
                ) : (
                  <div className="resNavListItem" onClick={handleSlideOut}>
                    <NavLink
                      to="/admin/class-management"
                      activeClassName="anchorActive"
                      className="anchorTxt"
                    >
                      <img
                        ref={refActiveIcon}
                        src="/images/icons/classes.png"
                        alt="schedule icon"
                        className={`${pathname.match("/admin/class-management")
                          ? "resSpanIcon"
                          : "resSpanIcon invertGray"
                          }`}
                      />
                      <span>{language.classes}</span>
                    </NavLink>
                  </div>
                )}
                {(role === "Admin" || role === "subAdmin") && (
                  <>
                    <div className="resNavListItem" onClick={handleOpenReports}>
                      <NavLink
                        to="/class-reports/attendanceReports"
                        activeClassName="anchorActive"
                        className="anchorTxt"
                      >
                        <img
                          ref={refActiveIcon}
                          src="/images/blue/reports.png"
                          alt="schedule icon"
                          className={`${pathname.match("/class-reports/attendanceReports")
                            ? "resSpanIcon"
                            : "resSpanIcon invertGray"
                            }`}
                        />
                        <span>{language.reports}</span>
                      </NavLink>
                      {openReports ? <ExpandLess /> : <ExpandMore />}
                    </div>
                    <Collapse in={openReports} timeout="auto" unmountOnExit>
                      <div className="resNavListItem" onClick={handleSlideOut}>
                        <NavLink
                          activeClassName="anchorActive"
                          to="/class-reports/attendanceReports"
                          className="anchorTxt menuItemLinks nestedListItem"
                        >
                          <span>{language.attendance}</span>
                        </NavLink>
                      </div>
                      <div className="resNavListItem" onClick={handleSlideOut}>
                        <NavLink
                          activeClassName="anchorActive"
                          to="/class-reports/assessmentReports"
                          className="anchorTxt menuItemLinks nestedListItem"
                        >
                          {language.assessments}
                        </NavLink>
                      </div>
                    </Collapse>
                  </>
                )}
                <div className="resNavListItem" onClick={handleSlideOut}>
                  <NavLink
                    to="/myprofile"
                    activeClassName="anchorActive"
                    className="anchorTxt"
                  >
                    <img
                      ref={refActiveIcon}
                      src="/images/blue/myprofile.png"
                      alt="my meetings icon"
                      className={`${pathname.match("/myprofile")
                        ? "resSpanIcon"
                        : "resSpanIcon invertGray"
                        }`}
                    />
                    <span>{language.instavc_dashboard_myprofile}</span>
                  </NavLink>
                </div>
                <div className="resNavListItem" onClick={handleSlideOut}>
                  <NavLink
                    to="/settings"
                    activeClassName="anchorActive"
                    className="anchorTxt"
                  >
                    <img
                      ref={refActiveIcon}
                      src="/images/blue/settings.png"
                      alt="my meetings icon"
                      className={`${pathname.match('/settings"')
                        ? "resSpanIcon"
                        : "resSpanIcon invertGray"
                        }`}
                    />
                    <span>{language.instavc_dashboard_settings}</span>
                  </NavLink>
                </div>
              <div className="resNavListItem" onClick={handleSlideOut}>
                  <a
                    className="anchorTxt" href={config.helpCenterUrl} target="_blank">
                    <img
                      ref={refActiveIcon}
                      src="/images/play-button.png"
                      alt="help center icon"
                      className={`${
                        pathname.match('/settings"')
                          ? "resSpanIcon invertPrimary"
                          : "resSpanIcon invertGray"
                      }`}
                    />
                    <span>{language.help_Center}</span>
                  </a>
                </div>
              </div>
              <div className="resNavListGroup noteBlock">
                <div className="resNavListItem" onClick={handleLogout}>
                  <NavLink to="/" className="anchorTxt">
                    <img
                      ref={refActiveIcon}
                      src="/images/blue/logout.png"
                      alt="my meetings icon"
                      className="resSpanIcon invertGray"
                    />
                    <span>{language.instavc_dashboard_logout}</span>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={mobShade ? "resNavShade fadeInShade" : "resNavShade"}
        onClick={handleSlideOut}
      />
    </>
  );
}
export default ResponsiveSideNav;
